module.exports = __webpack_public_path__ + "static/media/cover.1a0afc54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/maitres/cover.jpg
// module id = 63
// module chunks = 0